import React from 'react';
import { tableCustomStyles } from 'common/style/tableCustomStyle';
import DataTable from 'react-data-table-component';
import KSpinner from 'common/component/KSpinner';

export const UserTable = (props: any) => {
  const { data, table, setLimit, setPage, defaultPage, eachData, user, paginationServer } = props;

  const handlePageChange = (page: number) => {
    const currentPage = page;
    setPage((pre: any) => ({ ...pre, [user]: currentPage }));
  };
  const handlePerRowsChange = (newLimit: number) => {
    setLimit(newLimit);
  };

  return (
    <>
      {data.status === 'loading' && <KSpinner />}

      {data.status === 'data' && (
        <DataTable
          customStyles={tableCustomStyles}
          className="data-table"
          noHeader
          highlightOnHover
          data={eachData}
          columns={table}
          pagination
          paginationServer={paginationServer}
          paginationPerPage={10}
          paginationTotalRows={data.data.totalCount}
          paginationDefaultPage={defaultPage}
          onChangePage={(page) => handlePageChange(page)}
          onChangeRowsPerPage={(newLimit) => handlePerRowsChange(newLimit)}
          paginationComponentOptions={{ noRowsPerPage: true }}
          responsive={true}
        />
      )}
    </>
  );
};

export default UserTable;
